import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Loading = ({ height = '100vh' }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height
      }}
    >
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Caricamento...</span>
      </Spinner>
    </div>
  );
};

Loading.propTypes = {
  height: PropTypes.string
};

export default Loading;
